import { createMandatoryContext } from '@change-corgi/core-react/context';

import type { CaptchaHostStore } from './captchaHostStore';

export const {
	Context: CaptchaHostStoreContext,
	Provider: CaptchaHostStoreProvider,
	useContext: useCaptchaHostStoreContext,
} = createMandatoryContext<CaptchaHostStore>(undefined, {
	name: 'CaptchaHostStoreContext',
});
